import { create } from "zustand";

export type TaxType = {
    tax_rate: number;
    numeric: string,
    currency: Array<string>;
}

export type TaxContext = {
    tax: TaxType | null;
    setTax: (tax: TaxType) => void;
}

export const useTaxContext = create<TaxContext>()(
    (set) => ({
        tax: null,
        setTax: (tax) => {
            set({ tax: tax });
        }
    })
)